<div class="modal-header">
  <div class="h5-text modal-title w-100" id="PgfWelcomeModal">Nicola Wealth Private Giving Foundation Portal</div>
  <button type="button" class="close" (click)="activeModal.dismiss('Cross click')" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <p>Welcome!</p>
  <p>Through this new page, you can now easily see your charitable impact, view recent transactions, and submit requests for new donations to the fund and grants to charities.</p>
  <p>As you explore the portal, you’ll find pending and completed items, duplicate tax receipts and charity letters, and more about what drives Nicola Wealth in our core value of Sharing the Pie.</p>
  <p>If you’re looking for detailed information on assets held within the account, it is in the Performance tab.</p>
  <p>We are pleased to offer you this more detailed look at the positive impact you’re making through your donor advised fund.</p>
  <p>Thank you for choosing Nicola Wealth Private Giving Foundation for your philanthropic journey. Let us know what you think!</p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">Close</button>
</div>